import React, { useEffect, useState } from 'react';
import { Modal } from 'antd';

interface Props {
    open: boolean;
    currentName: string;
    onConfirm: (name: string) => Promise<void>;
    onClose: () => void;
}

const RenameModal: React.FC<Props> = ({ open, currentName, onConfirm, onClose }) => {
    const [name, setName] = useState(currentName);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (open) setName(currentName);
    }, [open, currentName]);

    const handleOk = async () => {
        const trimmed = name.trim();
        if (!trimmed || trimmed === currentName) { onClose(); return; }
        setLoading(true);
        try {
            await onConfirm(trimmed);
            onClose();
        } finally {
            setLoading(false);
        }
    };

    return (
        <Modal
            title="Đổi tên tệp"
            open={open}
            onOk={handleOk}
            onCancel={onClose}
            okText="Lưu"
            cancelText="Hủy"
            confirmLoading={loading}
            okButtonProps={{ disabled: !name.trim() || name.trim() === currentName }}
            width={400}
        >
            <input
                autoFocus
                type="text"
                value={name}
                maxLength={80}
                onChange={e => setName(e.target.value)}
                onKeyDown={e => e.key === 'Enter' && handleOk()}
                className="w-full rounded-md border border-border px-3 py-2 text-sm outline-none focus:border-primary"
                style={{ marginTop: 8 }}
            />
        </Modal>
    );
};

export default RenameModal;
